export type RoleCode = 'admin' | 'chief_accountant' | 'accountant';

export type LanguageCode = 'az' | 'en' | 'ru';

export interface SessionUser {
  id: string;
  email: string;
  fullName: string;
  locale: LanguageCode;
  isActive: boolean;
  roles: RoleCode[];
  permissions: string[];
  createdAt: string;
  updatedAt: string;
}

/** The login/refresh payload: tokens and the user they belong to. */
export interface AuthSession {
  accessToken: string;
  refreshToken: string;
  tokenType: 'Bearer';
  expiresIn: number;
  refreshExpiresIn: number;
  user: SessionUser;
}

export function isAuthSession(value: unknown): value is AuthSession {
  if (value === null || typeof value !== 'object') {
    return false;
  }
  const candidate = value as Partial<AuthSession>;
  return (
    typeof candidate.accessToken === 'string' &&
    typeof candidate.refreshToken === 'string' &&
    candidate.user !== undefined &&
    typeof candidate.user === 'object' &&
    Array.isArray(candidate.user.roles) &&
    Array.isArray(candidate.user.permissions)
  );
}

/** Client-side mirror of the server rule: `*` grants everything. */
export function can(permissions: readonly string[] | undefined, required: string | undefined): boolean {
  if (required === undefined) {
    return true;
  }
  if (!permissions) {
    return false;
  }
  const wanted = required.trim().toLowerCase();
  return permissions.some((code) => {
    const normalized = code.trim().toLowerCase();
    return normalized === '*' || normalized === wanted;
  });
}
